module.exports = __webpack_public_path__ + "img/timer-dark.40e2e78.svg";